import { LOGIN } from "../constants";

export const loginAction = () => {
  return {
    type: LOGIN,
  };
};
